import useUser from '@hooks/auth/useUser';
import { registerToken } from '@utils/nativeUtils';
import { useEffect } from 'react';

function useRegisterToken() {
    const { user } = useUser();
    useEffect(() => {
        if (user) {
            registerToken(user.id);
        }
    }, [user]);
}
export default useRegisterToken;
